import React, { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Confirm", onConfirm, financial = false, confirmWord = "CONFIRM", destructive = false, testId = "confirm" }) {
  const [typed, setTyped] = useState("");
  const ok = !financial || typed.trim().toUpperCase() === confirmWord.toUpperCase();

  const handleConfirm = () => {
    onConfirm();
    setTyped("");
  };

  return (
    <AlertDialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setTyped(""); }}>
      <AlertDialogContent data-testid={`${testId}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {financial && (
          <div className="space-y-2">
            <Label className="text-xs text-slate-500">Type <span className="font-mono font-semibold text-slate-900">{confirmWord}</span> to proceed</Label>
            <Input data-testid={`${testId}-input`} value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={confirmWord} />
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testId}-confirm`}
            disabled={!ok}
            onClick={handleConfirm}
            className={destructive ? "bg-rose-600 hover:bg-rose-700" : "bg-blue-600 hover:bg-blue-700"}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
